"use strict";
/** @module utils */
Object.defineProperty(exports, "__esModule", { value: true });
var uuid_1 = require("uuid");
var models_1 = require("../models");
var localstorage_logger_1 = require("localstorage-logger");
// import { JobType } from '../models/jobType';
/**
 * Class to read and write Bryx and Bryx site specific values
 * to the window's localStorage.
 */
var BryxLocalStorage = /** @class */ (function () {
    /**
     * Contruct BryxLocalStorage object based on config.
     * @TODO Possibly revise naming.
     * @param Config
     */
    function BryxLocalStorage(config) {
        if (config === void 0) { config = { serverType: 'dev', site: 'test', version: '0' }; }
        this.requiredKeysForSignIn = ['apiKey'];
        // constructor(config: Config) {
        this.version = config.version;
        this.prefix = "com.bryx." + config.site + ".";
        this.deviceIdPrefix = "global.bryx." + config.site + ".deviceId";
        this.log = localstorage_logger_1.default({
            logName: "bryx-" + config.serverType + "-log",
            maxLogSizeInBytes: 500 * 1024,
        });
    }
    /**
     * Get item from local storage by key.
     * @param key Key of item.
     * @return Item specified by key. Null if no item found.
     */
    BryxLocalStorage.prototype.getValue = function (key) {
        var item = localStorage.getItem(this.prefix + key);
        return item ? JSON.parse(item) : null;
    };
    /**
     * Set item in local storage.
     * @param key Key of item.
     * @param value Value of item.
     */
    BryxLocalStorage.prototype.setValue = function (key, value) {
        if (value !== undefined) {
            localStorage.setItem(this.prefix + key, JSON.stringify(value));
        }
    };
    /**
     * Get all Bryx values in local storage.
     * @return Object containing all Bryx items in local storage.
     */
    BryxLocalStorage.prototype.getBryxItems = function () {
        var _this = this;
        var bryxItems = {};
        Object.keys(localStorage)
            .filter(function (key) { return key.indexOf(_this.prefix) == 0; })
            .forEach(function (key) { bryxItems[key] = localStorage.getItem(key); });
        bryxItems.appVersion = this.version;
        return bryxItems;
    };
    /**
     * Get value from local storage by key.
     * @typeparam T Type of value being retrieved.
     * @param key Key of value.
     * @return Value specified by key. Null if no value found.
     */
    BryxLocalStorage.prototype.get = function (key) {
        return this.getValue(key);
    };
    /**
     * Set value in local storage.
     * @typeparam T Type of value being stored.
     * @param key Key of value.
     * @param value
     */
    BryxLocalStorage.prototype.set = function (key, value) {
        return this.setValue(key, value);
    };
    /**
     * Clear all BRyx values from localStorage.
     * @TODO May not clear deviceId.
     */
    BryxLocalStorage.prototype.clear = function () {
        var _this = this;
        Object.keys(localStorage)
            .filter(function (key) { return key.indexOf(_this.prefix) == 0; })
            .forEach(function (key) { localStorage.removeItem(key); });
    };
    /**
     * Check if values required for sign in are present.
     * @return True if values exist.
     */
    BryxLocalStorage.prototype.isSignedIn = function () {
        var _this = this;
        return this.requiredKeysForSignIn.every(function (k) { return _this.get(k) != null; });
    };
    /**
     * Get device id from local storage.
     * Set device id if one does not already exist.
     * @return Device ID.
     */
    BryxLocalStorage.prototype.getDeviceId = function () {
        var currentId = localStorage.getItem(this.deviceIdPrefix);
        if (currentId == null) {
            currentId = uuid_1.v4();
            // this.set(BryxLocal.deviceIdPrefix, currentId);
            localStorage.setItem(this.deviceIdPrefix, JSON.stringify(currentId));
        }
        return currentId;
    };
    /**
     * Initialize values using AuthModel object.
     * @param authModel
     */
    BryxLocalStorage.prototype.initValuesFromAuthModel = function (authModel) {
        var _this = this;
        if (authModel instanceof models_1.ManageAuth || authModel instanceof models_1.AccountAuth) {
            this.setValue('selfId', authModel.id);
        }
        this.setValue('apiKey', authModel.apiKey);
        this.setValue('showEula', authModel.showEula);
        this.setValue('email', authModel.email); // KLUDGE FIX
        this.setValue('fullName', authModel.givenName + " " + authModel.surname); // KLUDGE FIX
        // KLUDGE
        Object.keys(authModel).forEach(function (k) {
            if (k !== 'apiKey' &&
                k !== 'showEula' &&
                k !== 'email' &&
                k !== 'givenName' &&
                k !== 'surname') {
                _this.setValue(k, authModel[k]);
            }
        });
    };
    /**
     * Log info.
     * @param args Values to log.
     */
    BryxLocalStorage.prototype.logInfo = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        (_a = this.log).info.apply(_a, args);
    };
    /**
     * Log debug.
     * @param args Values to log.
     */
    BryxLocalStorage.prototype.logDebug = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        (_a = this.log).debug.apply(_a, args);
    };
    /**
     * Log error.
     * @param args Values to log.
     */
    BryxLocalStorage.prototype.logError = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        (_a = this.log).error.apply(_a, args);
    };
    /**
     * Log warn.
     * @param args Values to log.
     */
    BryxLocalStorage.prototype.logWarn = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        (_a = this.log).warn.apply(_a, args);
    };
    Object.defineProperty(BryxLocalStorage.prototype, "logEntries", {
        /**
         * Get log entries as array.
         * @return Log enrties.
         */
        get: function () {
            return this.log.exportToArray();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BryxLocalStorage.prototype, "deviceId", {
        /**
         * Get device id from local storage.
         * Set device id if one does not already exist.
         * @return Device ID.
         */
        get: function () {
            var currentId = localStorage.getItem(this.deviceIdPrefix);
            if (currentId == null) {
                currentId = uuid_1.v4();
                // this.set(BryxLocal.deviceIdPrefix, currentId);
                localStorage.setItem(this.deviceIdPrefix, JSON.stringify(currentId));
            }
            return currentId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BryxLocalStorage.prototype, "selfId", {
        /**
         * Get selfId value.
         * @return selfId value or null.
         */
        get: function () {
            return this.getValue('selfId');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BryxLocalStorage.prototype, "apiKey", {
        /**
         * Get apiKey value.
         * @return apiKey value or null.
         */
        get: function () {
            return this.getValue('apiKey');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BryxLocalStorage.prototype, "email", {
        /**
         * Get email value.
         * @return email value or null.
         */
        get: function () {
            return this.getValue('email');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BryxLocalStorage.prototype, "fullName", {
        /**
         * Get fullName value.
         * @return fullName value or null.
         */
        get: function () {
            return this.getValue('fullName');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BryxLocalStorage.prototype, "showEula", {
        /**
         * Get showEula value.
         * @return If showEula.
         */
        get: function () {
            return this.getValue('showEula');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BryxLocalStorage.prototype, "currentAgencyId", {
        /**
         * Get currentAgencyId value.
         * @return currentAgencyId.
         */
        get: function () {
            return this.get('agencyId');
        },
        /**
         * Set currentAgencyId value.
         */
        set: function (agencyId) {
            this.set('agencyId', agencyId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BryxLocalStorage.prototype, "selfUser", {
        /**
         * Get selfUser value.
         */
        get: function () {
            var id = this.selfId;
            var commonName = this.fullName;
            var email = this.email;
            if (id == null || commonName == null || email == null) {
                return null;
            }
            return new models_1.FindUser(id, commonName, email);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BryxLocalStorage.prototype, "createJobType", {
        /**
         * Get createJobType value.
         */
        get: function () {
            return this.get('createJobType');
        },
        /**
         * Set createJobType value.
         */
        set: function (jobType) {
            this.set('createJobType', jobType);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BryxLocalStorage.prototype, "overrideAPIRoot", {
        get: function () {
            return this.get('apiRoot');
        },
        set: function (apiRoot) {
            this.set('apiRoot', apiRoot);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BryxLocalStorage.prototype, "signupRestrictions", {
        get: function () {
            return this.get('signupRestrictions');
        },
        set: function (restrictions) {
            this.set('signupRestrictions', restrictions);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BryxLocalStorage.prototype, "signupStatusFilters", {
        get: function () {
            return this.get('signupStatusFilters');
        },
        set: function (filters) {
            this.set('signupStatusFilters', filters);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BryxLocalStorage.prototype, "signupProductTypeFilter", {
        get: function () {
            return this.get('signupProductTypeFilter');
        },
        set: function (filter) {
            this.set('signupProductTypeFilter', filter);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BryxLocalStorage.prototype, "copyJSONOnCreateSCU", {
        get: function () {
            return this.get('copyJSONOnCreateSCU') != false;
        },
        set: function (value) {
            this.set('copyJSONOnCreateSCU', value);
        },
        enumerable: false,
        configurable: true
    });
    return BryxLocalStorage;
}());
exports.default = BryxLocalStorage;
//# sourceMappingURL=BryxLocalStorage.js.map